import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import "@ui5/webcomponents/dist/List.js";
import "@ui5/webcomponents/dist/StandardListItem.js";
import "@ui5/webcomponents/dist/Popover.js";
import "@vaadin/vaadin-icons/vaadin-icons.js";
import { Router } from "@vaadin/router";

class KbLangSelector extends LitElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    if (this.state.global_langs) {
      this.myRender();
    }
  }

  myRender() {
    if (this.state.global_langs.length > 1) {
      if (this.state.current_lang_object) {
        render(this.langSelectorDropdownTemplate(), this.shadowRoot);
        // this.popover = this.shadowRoot.querySelector("#langs-popover");
      }
    }
  }

  langFlag(lang) {
    if (lang.locale) {
      return html`<img
        src="/kb/flags/${lang.locale.toLowerCase()}.svg"
        width="16px"
      />`;
    }
  }

  langSelectorListTemplate() {
    return html`
        <style>
            #langselector{
                color: var(--kb-on-primary-color);
                float: right;
            }
            #langselector ul{
                list-style:none;
            }
            #langselector ul li{
                display:inline;
                margin-right:1rem;
                cursor: pointer;
                font-size: var(--kb-button-font-size-small);
            }
        </style>
        <div id='langselector'>  
            <ul>
            ${this.state.global_langs.map(
              (lang) =>
                html`<li @click="${this._selectLang.bind(this, lang)}">
                  ${this.langFlag(lang)} ${lang.description}
                </li>`
            )}
            <ul>
        </div>
        `;
  }
  langSelectorDropdownTemplate() {
    return html` <style>
        .lang-text {
          display: none;
        }

        #langselector {
          color: var(--kb-on-primary-color);
          margin-right: 1rem;
          display: inline-block;
        }
        #lang {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 5px;
        }
        #langicon {
          width: 0.8rem;
        }
        @media only screen and (min-width: 640px) {
          .lang-text {
            display: inline;
          }
        }
      </style>
      <div id="langselector">
        <span id="lang" @click="${this._openLangPopover.bind(this)}">
          ${this.langFlag(this.state.current_lang_object)}
          <!-- <span class="lang-text"
            >${this.state.current_lang_object.description}</span
          > -->
          <iron-icon id="langicon" icon="vaadin:arrow-circle-down"></iron-icon>
        </span>
      </div>

      <ui5-popover id="langs-popover">
        <ui5-list>
          ${this.state.global_langs.map(
            (lang) =>
              html`<ui5-li @click="${this._selectLang.bind(this, lang)}"
                >${this.langFlag(lang)} ${lang.description}</ui5-li
              >`
          )}
        </ui5-list>
      </ui5-popover>`;
  }

  _openLangPopover(e) {
    var el = e.currentTarget;
    this.shadowRoot.querySelector("#langs-popover").showAt(el);
  }
  _selectLang(lang, e) {
    if (this.popover) {
      this.popover.close();
    }
    if (lang.langCode != this.state.langCode) {
      window.location.href = "/kb/" + lang.langCode;
      // storeInstance.dispatch("setState", {property: 'langCode' , value: lang.langCode } )
      //Router.go("/kb/" + lang.langCode )
    }
  }
}

customElements.define("kb-lang-selector", KbLangSelector);
